<template>
  <div class="min-h-screen h-full scroll-smooth overflow-auto">
    <div class="content-page">
      <div class="flex flex-col justify-between min-h-screen h-full container bg-white gap-2 xl:gap-4 px-2 sm:px-4 md:px-8 lg:px-12 xl:px-16">
        <LandingNavbar class="border-b-2" />
        <main class="flex flex-col justify-center w-full h-full">
          <slot />
        </main>
        <LandingFooter />
      </div>
    </div>
    <LandingCookies class="content" />
    <LandingHelp class="content" />
    <div class="content-resolution-notice">
      <div class="flex flex-col justify-center items-center min-h-screen h-full align-middle text-center bg-red-200 text-xl text-slate-900 font-bold z-[99]">
        Toto rozlíšenie nie je podporované.
      </div>
    </div>
  </div>
</template>
